import { Navigate } from "react-router-dom";

export default function GuestRoute({ element }) {
    const guestID = localStorage.getItem("guestID");
    const guestName = localStorage.getItem("guestName");
    return guestID && guestName ? <Navigate to="/chat" replace /> : element;
}
